export default __webpack_public_path__ + "static/media/escrow-warehousing_original.50c48826.png";